import { BuilderTypes } from "./BuilderTypes";
import { BuilderChangeSetUnitTestFailure } from "./BuilderChangeSetUnitTestFailure";

export class BuilderChangeSetMergeIssue {
    type: BuilderTypes;
    id: string;
    unitTestFailures: BuilderChangeSetUnitTestFailure[] = [];
    conflictingMerge: boolean = false;
    changeSetConfiguration: object;
    changeSetInitialConfiguration: object;
    mainConfiguration: object;

    constructor(
        type: BuilderTypes,
        id: string,
        unitTestFailures: BuilderChangeSetUnitTestFailure[],
        conflictingMerge: boolean,
        changeSetConfiguration: object,
        changeSetInitialConfiguration: object,
        mainConfiguration: object
    ) {
        this.type = type;
        this.id = id;
        this.unitTestFailures = unitTestFailures;
        this.conflictingMerge = conflictingMerge;
        this.changeSetConfiguration = changeSetConfiguration;
        this.changeSetInitialConfiguration = changeSetInitialConfiguration;
        this.mainConfiguration = mainConfiguration;
    }
}

export class BuilderChangeSetMergeIssues {
    type: BuilderTypes;
    id: string;
    unitTestFailures: BuilderChangeSetUnitTestFailure[] = [];
    conflictingMerge: boolean = false;

    constructor(
        type: BuilderTypes,
        id: string,
        unitTestFailures: BuilderChangeSetUnitTestFailure[],
        conflictingMerge: boolean
    ) {
        this.type = type;
        this.id = id;
        this.unitTestFailures = unitTestFailures;
        this.conflictingMerge = conflictingMerge;
    }
}
